<template>
    <div>
        <el-submenu v-if="child.subOrganizations.length" :index="child.uuid" v-for="child in model" :class="{ 'el-menu-active': isActive(child) }">
            <template slot="title" >{{ child.name }}</template>
            <dq-sidemenu class="item" :model="child.subOrganizations"></dq-sidemenu>
        </el-submenu>
        <el-menu-item v-else :index="child.uuid" @click="goToRoute(child.uuid)" :class="{ 'el-menu-active': isActive(child) }">{{ child.name }}</el-menu-item>
    </div>
</template>

<script>
  export default {
    name: 'DqSidemenu',
    props: {
      model: ''
    },
    methods: {
      goToRoute (uuid) {
        if (this.$route.name !== 'management.unit.read') {
          this.$router.push({
            params: {
              uuid: uuid
            },
            name: this.$route.name
          })
        }
      },
      isActive (child) {
        if (this.$route.name !== 'management.unit.read') {
          return child.uuid === this.$route.params.uuid
        }
        let parents = this.$store.getters['generalSession/getCurrentSession'].parentUuids
        for (let index in parents) {
          let parentUuid = parents[index]
          if (child.uuid === parentUuid) {
            return true
          }
        }
        return false
      }
    }
  }
</script>






// WEBPACK FOOTER //
// sidemenu.vue?6f8630de